import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, SectionHeading, Reveal, CTAButton, Overline } from "../components/Kinetic";

const AssociationPage = () => {
  const { t } = useLanguage();
  useSEO(t("presentation.metaTitle"), t("presentation.metaDesc"));
  const identity = t("presentation.identity");
  const objet = t("presentation.objet");
  const gov = t("presentation.gov");
  const fonctionnement = t("presentation.fonctionnement");

  return (
    <div data-testid="association-page">
      <PageHero
        overline={t("presentation.overline")}
        titleLines={t("presentation.titleLines")}
        intro={t("presentation.intro")}
        testid="association"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("presentation.identityOverline")} title={t("presentation.identityTitle")} />
          <div className="mt-14 grid gap-px bg-graphite/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="association-identity">
            {identity.map((item, i) => (
              <Reveal key={item.label} delay={i * 0.04} className="bg-bone p-7">
                <p className="overline-mono text-forest">{item.label}</p>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-graphite">{item.value}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-graphite py-24 text-white md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-2">
          <SectionHeading
            overline={t("presentation.objetOverline")}
            title={t("presentation.objetTitle")}
            text={t("presentation.objetIntro")}
            light
          />
          <ul>
            {objet.map((item, i) => (
              <Reveal key={item} delay={i * 0.04} y={12}>
                <li className="flex items-baseline gap-5 border-b border-white/10 py-4">
                  <span className="font-mono text-xs text-[#4ADE80]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-sm md:text-base text-white/80">{item}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("presentation.govOverline")} title={t("presentation.govTitle")} />
          <div className="mt-14 grid gap-px bg-graphite/10 sm:grid-cols-2 lg:grid-cols-5" data-testid="association-gov">
            {gov.map((m, i) => (
              <Reveal key={m.role} delay={i * 0.06} className="bg-bone p-7">
                <p className="overline-mono text-forest">{m.role}</p>
                <p className="mt-4 font-display text-lg font-light tracking-tight leading-snug text-graphite">{m.name}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-3xl border-l-2 border-forest pl-6 text-sm leading-relaxed text-graphite-soft">
              {t("presentation.govNote")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-graphite/10 bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-2">
          <SectionHeading overline={t("presentation.fonctionnementOverline")} title={t("presentation.fonctionnementTitle")} />
          <ul>
            {fonctionnement.map((item, i) => (
              <Reveal key={item} delay={i * 0.05} y={12}>
                <li className="flex items-baseline gap-5 border-b border-graphite/10 py-4">
                  <span className="font-mono text-xs text-forest">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-sm md:text-base text-graphite">{item}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-forest py-20 text-white md:py-28">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-6">
          <Reveal>
            <Overline light>Green Horizon Project</Overline>
            <p className="mt-4 max-w-xl font-display text-2xl md:text-3xl font-light tracking-tight">
              {t("brand.message")}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="flex flex-wrap gap-4">
              <CTAButton to="/ressources" variant="light" testid="association-cta-docs">
                {t("presentation.docsCta")}
              </CTAButton>
              <CTAButton to="/contact" variant="outlineLight" testid="association-cta-contact">
                {t("presentation.contactCta")}
              </CTAButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default AssociationPage;
